import {createContext, useEffect, useState} from 'react';
import axios from 'axios';
import { API_URL } from '../apiUrl';

const Contex = createContext(null);

const Provider = ({children})=>{
    const [product, setProduct] = useState([]);
    const [category, setCategory] = useState([]);
    const [banner, setBanner] = useState([]);
    const [service, setService] = useState([]);

    const getDataProduct = async () => {
        const response = await axios.get(`${API_URL}/product`);
        setProduct(response.data);
    }
    const getDataCategory = async () => {
        const response = await axios.get(`${API_URL}/category`);
        setCategory(response.data);
    }
    const getDataBanner = async () => {
        const response = await axios.get(`${API_URL}/banner`);
        setBanner(response.data);
    }
    const getDataService = async () => {
        const response = await axios.get(`${API_URL}/service`);
        setService(response.data);
    }

    const [searchTerm, setSearchTerm] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchAllData = async () => {
            setIsLoading(true);
            try {
                await Promise.all([
                    getDataProduct(),
                    getDataCategory(),
                    getDataBanner(),
                    getDataService()
                ]);
            } catch (error) {
                console.error("Error fetching initial data:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchAllData();
    },[])

    return (
        <Contex.Provider value={{product, category, banner, service, searchTerm, setSearchTerm, isLoading}}>
            {children}
        </Contex.Provider>
    )
}

export {Contex, Provider}